module.exports = __webpack_public_path__ + "static/img/back-10-1.212238f7.png";